import React, { useMemo, useState } from 'react'
import ReactScrollLink from '../General/ReactScollLink'
import SliderBasicLinkButton from '../SliderBasic/SliderBasicLinkButton'
import Actors from '../MovieInformation/Actors'
import Directors from '../MovieInformation/Directors'
import MovieLength from '../MoviesGeneral/MovieLength'
import Translation from '../General/Translation'
import getTranslationTime from '../functions/getTranslationTime'
import TrailerLarge from '../Trailer/TrailerLarge'
import BackgroundVisuals from '../BackgroundVisuals/BackgroundVisuals'
import getMovieTitle from '../functions/getMovieTitle'
import getBackgroundsUrlsObj from '../functions/getBackgroundsUrlsObj'
import getBackgroundPosterObj from '../functions/getBackgroundPosterObj'
import getBackgroundStyles from '../functions/getBackgroundStyles'
import TrailerSmall from '../Trailer/TrailerSmall'
import intersperse from '../functions/intersperse'
import getImageUrl from '../functions/getImageUrl'
import SliderBasicTitle from '../SliderBasic/SliderBasicTitle'
import Length from '../MovieInformation/Length'
import Fsk from '../MovieInformation/Fsk'
import ItemAttributes from '../PosterFormatItem/ItemAttributes'
import seperateAttributes from '../functions/seperateAttributes'
import Genres from '../MovieDetails/Genres'
import CountdownContainer from '../MovieInformation/CountdownContainer'
import getMomentDateObj from '../functions/getMomentDateObj'
import setMomentDateObjZero from '../functions/setMomentDateObjZero'
import getMomentNow from '../functions/getMomentNow'
import { useCountdown } from '../hooks/useCountdown'
import FskWrapper from '../MovieInformation/FskWrapper'
import getCinemasPerMovie from '../functions/getCinemasPerMovie'
import SandwichElementTitle from '../SliderBasic/SandwichElementTitle'

const Highlight = ({items, theme, moviesData, isMobile, highlights, backgroundVisualsSettings, hiddenAttributes, attributeStyling, highlightAppearance, translation, scrollToPosition, onClickItem}) => {
    const [fallbackInUse, setFallback] = useState(false)

    const currentHighlight = highlights[items[0].id]
    if(!currentHighlight) {
        return ''
    }
    const {text, movieRefID} = currentHighlight

    const currentHighlightTitle = currentHighlight.title

    if(!moviesData[movieRefID]) {
        return ''
    }

    const movieData = moviesData[movieRefID]
    const { title, fsk, directors, actors, descriptionShort, performances, images, trailerURL, startingDate, length, genres, productionCountry, productionYear, technologyAttributes, limitations } = movieData
    const cinemas = getCinemasPerMovie(performances)
    const {visibleFrom, showCountdown} = limitations
    const countdownNumbers = useCountdown(visibleFrom);
    const { timezone } = translation
    const today = setMomentDateObjZero(getMomentNow(timezone))
    //TESTING COUNTDOWN!!!
    // const today = setMomentDateObjZero(getMomentDateObj(1711120780000, timezone))
    let purchaseblePerformances =  _.filter(performances, performance => {
        const {limitations} = performance

        if(limitations.visibleFrom) {
            // return new Date().getTime() - 5260550000 > limitations.visibleFrom
            const performanceDate = getMomentDateObj(limitations.visibleFrom, timezone)

            return getMomentNow(timezone).isAfter(performanceDate)
        } else {
            return true
        }
    })

    const hasPerformance = 0 !== purchaseblePerformances.length
    const formatedDate = startingDate ? getTranslationTime('cinemaStart', translation, startingDate) : visibleFrom ? getTranslationTime('cinemaStart', translation, visibleFrom) : null
    const currentTitle  = getMovieTitle(movieData)
    let interspersedGenres

    const backgroundsObj = useMemo(
        () => getBackgroundsUrlsObj(images), 
        [images]
    )

    const backgroundPoster = getBackgroundPosterObj(images)

    if(genres && genres[0]) {
        interspersedGenres = intersperse(genres, ', ')
    }

    const linkText = hasPerformance ? <Translation id="tickets" trans={translation}>Tickets</Translation> : ((showCountdown && visibleFrom) || (!showCountdown && !visibleFrom)) ? <span><Translation id="availableFrom" trans={translation}>Verfügbar ab</Translation> {formatedDate}</span> : <Translation id="information" trans={translation}>Informationen</Translation>
    const ticketButtonClass = hasPerformance ? ' has-performances' : ''
    const ambientStyle = getBackgroundStyles(backgroundsObj.ambient, true, isMobile)
    const posterStyle = getBackgroundStyles(backgroundPoster, true, isMobile)
    const backgroundImage = backgroundPoster ? getImageUrl(backgroundPoster, isMobile, true) : null
    const finalImageURl = backgroundImage ? backgroundImage.finalImageURl : null
    const imageUrl = backgroundImage ? backgroundImage.imageUrl : null
    const position = backgroundImage ? backgroundImage.position : null
    const {technologyAttributesWithIcons} = seperateAttributes(technologyAttributes)
    const noAttributesWithIconsToDisplay = ((technologyAttributesWithIcons.length === 1 && (technologyAttributesWithIcons[0].id === '2d' || technologyAttributesWithIcons[0].id === '1087')) || technologyAttributesWithIcons.length === 0) ? true : false


    if(theme === 'Arthouse') {  
        if(highlightAppearance === 'arthouse_2') {
            return (
                <div className={"image-wrapper"}>
                    <div className='image-section'>
                        <BackgroundVisuals
                            isInHighlight={true}
                            oddSlide={false}
                            backgroundVisualsSettings={backgroundVisualsSettings}
                            isMobile={isMobile}
                            backgroundImage={backgroundsObj.ambient}
                            posterUrl={backgroundPoster ? backgroundPoster : false}
                        />
                        {trailerURL && <TrailerSmall
                            trailerURL={trailerURL}
                            fsk={fsk}
                            translation={translation}
                            />
                        }
                    </div>
                    <div className='gradient'>
                        <div className={"slider-basic-item-content"}>
                            {currentHighlightTitle && <SandwichElementTitle title={currentHighlightTitle} cinemas={cinemas}/>}
                            <div className='slide-item-content-wrapper'>
                                <div className='top-section'>
                                    <SliderBasicTitle title={currentTitle}/>  
                                    <p className="actor-directors">
                                        <Actors actors={actors} translation={translation}/>
                                        <Directors actors={actors} directors={directors} translation={translation}/>
                                    </p>                        
                                    <p className={'headtext description text-large-medium'}dangerouslySetInnerHTML={{ __html: text ? text : descriptionShort}}></p>
                                </div>
                                <div className='bottom-section'>
                                    <div className='row-flex-information'>
                                        <Length length={length} translation={translation}/>
                                        <FskWrapper fsk={fsk}/>
                                        {!noAttributesWithIconsToDisplay && technologyAttributesWithIcons.length !== 0 && <div className='attributes-with-icons'>
                                            <ItemAttributes hiddenAttributes={hiddenAttributes} attributeStyling={attributeStyling} translation={translation} attributes={technologyAttributesWithIcons} canBeColored={true} />
                                        </div>}
                                    </div>
                                    <Genres genres={genres} theme={theme} translation={translation}/>
                                    {(formatedDate || visibleFrom) && showCountdown && !purchaseblePerformances[0] && <div className='countdown-wrapper'>
                                        <CountdownContainer translation={translation} countdownNumbers={countdownNumbers}/>
                                    </div>}
                                    <div>
                                        <div className="slider-item-link">
                                            <ReactScrollLink to={scrollToPosition + ' openMovieInformation'} className={movieRefID} smooth={true} offset={-200} onClick={() => onClickItem({id: movieRefID, movieTitle: title})}>  
                                                <SliderBasicLinkButton linkText={linkText} ticketButtonClass={ticketButtonClass} cinemas={cinemas}/>
                                            </ReactScrollLink>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )
        }
        return (
            <div className='arthouse-highlight'>
                <div className={"image-wrapper " + scrollToPosition}>
                    <BackgroundVisuals
                        isInHighlight={true}
                        oddSlide={false}
                        backgroundVisualsSettings={backgroundVisualsSettings}
                        isMobile={isMobile}
                        backgroundImage={backgroundsObj.ambient}
                        posterUrl={backgroundPoster ? backgroundPoster : false}
                    />

                    <div className='gradient-highlight'>
                        <div className={"slider-basic-item-content"}>
                            <p className="highlight-title title-large">{currentHighlightTitle}</p>

                            <div className="inner-content-wrapper">
                                <div className='top-content'>
                                    <h2 className={'headline title-xxlarge'} style={{whiteSpace: "pre-line"}} dangerouslySetInnerHTML={{ __html: currentTitle}}></h2>
                                    <div className='info-flex-wrapper'>
                                        <span>{interspersedGenres && interspersedGenres}{(productionCountry || productionYear) ? ',' : ''} </span>
                                        {productionCountry && <span>{productionCountry}, </span>}
                                        {productionYear && <span>{productionYear}</span>}
                                    </div>
                                    {(length || length !== 0) && <MovieLength length={length} translation={translation}/>}
                                    <Directors directors={directors} translation={translation}/>
                                    {(fsk || fsk === 0) && <FskWrapper labelFsk={true} fsk={fsk}/>}
                                </div>
                                <div className='bottom-content'>
                                    <p className={'headtext description text-large-medium'}dangerouslySetInnerHTML={{ __html: text ? text : descriptionShort}}></p>
                                    <div className="slider-item-link">
                                        {trailerURL && <TrailerSmall
                                            trailerURL={trailerURL}
                                            fsk={fsk}
                                            translation={translation}
                                            />
                                        }
                                        {(formatedDate || visibleFrom) && showCountdown && !purchaseblePerformances[0] && <div className='countdown-wrapper'>
                                            <CountdownContainer translation={translation} countdownNumbers={countdownNumbers}/>
                                        </div>}
                                        <ReactScrollLink to={scrollToPosition + ' openMovieInformation'} className={movieRefID} smooth={true} offset={-200} onClick={() => onClickItem({id: movieRefID, movieTitle: title})}>  
                                            <SliderBasicLinkButton linkText={linkText} ticketButtonClass={ticketButtonClass} cinemas={cinemas} />
                                        </ReactScrollLink>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    } else {
        return (
            <div>
                <div className={"image-wrapper " + scrollToPosition}>
                    <BackgroundVisuals
                        isInHighlight={true}
                        oddSlide={false}
                        backgroundVisualsSettings={backgroundVisualsSettings}
                        isMobile={isMobile}
                        backgroundImage={backgroundsObj.ambient}
                        posterUrl={backgroundPoster ? backgroundPoster : false}
                    />

                    <div className='gradient-highlight'>
                            {trailerURL ? <TrailerLarge 
                                trailerURL={trailerURL}
                                fsk={fsk}
                                isMobile={isMobile}
                                backgroundImage={backgroundsObj.details}
                                translation={translation}
                                landscape={true}
                                /> : <div className="trailer-wrapper-button trailer"></div>
                            }
                        <div className={"slider-basic-item-content"}>
                            <p className="highlight-title title-large">{currentHighlightTitle}</p>
                            <div className="inner-content-wrapper">
                                <h2 className={'headline title-xlarge-black'}>{currentTitle}</h2>
                                <div className="information">
                                    <div className="slider-item-text">
                                        <p className="actor-directors">
                                            <Actors actors={actors} translation={translation}/>
                                            <Directors actors={actors} directors={directors} translation={translation}/>
                                        </p>
                                        <p className={'headtext description text-large-medium'}dangerouslySetInnerHTML={{ __html: text ? text : descriptionShort}}></p>
                                        <div className='fsk-length-wrapper'>
                                            {(fsk || fsk === 0) && <FskWrapper labelFsk={true} fsk={fsk}/>}
                                            {(length || length !== 0) && <MovieLength length={length} translation={translation}/>}
                                        </div>
                                        {(formatedDate || visibleFrom) && showCountdown && !purchaseblePerformances[0] && <div className='countdown-wrapper'>
                                            <CountdownContainer translation={translation} countdownNumbers={countdownNumbers}/>
                                        </div>}
                                        <div className="slider-item-link">
                                            <ReactScrollLink to={scrollToPosition + ' openMovieInformation'} className={movieRefID} smooth={true} offset={-200} onClick={() => onClickItem({id: movieRefID, movieTitle: title})}>  
                                                <SliderBasicLinkButton linkText={linkText} ticketButtonClass={ticketButtonClass} cinemas={cinemas} />
                                            </ReactScrollLink>
                                        </div>
                                    </div>
                                    <div className="poster-image-wrapper">
                                        {finalImageURl && <img 
                                            src={finalImageURl} 
                                            className="poster-image"
                                            alt={currentTitle + ' Poster'} 
                                            onError={({ currentTarget }) => {
                                                if(fallbackInUse) {
                                                    currentTarget.onerror = null; 
                                                    currentTarget.src = '';
                                                } else {
                                                    setFallback(true)
                                                    currentTarget.onerror = null; 
                                                    currentTarget.src = imageUrl;
                                                }
                                            }}
                                        />}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}


export default Highlight